export class DeviceList {
    constructor(onChange) {
        this.onChange = onChange;
        this.ws = null;
        this.timer = null;
        this.devices = new Map();
        this.handleMessage = (ev) => {
            try {
                const msg = JSON.parse(ev.data);
                if (msg.type === 'devicelist') {
                    this.devices.clear();
                    for (const d of (msg.data?.list ?? [])) {
                        this.devices.set(d.udid, d);
                    }
                    this.onChange(this.devices);
                }
                else if (msg.type === 'device') {
                    const d = msg.data?.device;
                    if (d?.udid) {
                        this.devices.set(d.udid, d);
                        this.onChange(this.devices);
                    }
                }
                else if (msg.type === 'farm-health' && msg.data?.health) {
                    // Live machine-health sample for the farm dashboard. Re-dispatched as a
                    // window event so the (mount/unmount) Health tab can subscribe without
                    // threading a callback through here.
                    window.dispatchEvent(new CustomEvent('farm-health', { detail: msg.data }));
                }
            }
            catch { /* ignore */ }
        };
        this.connect();
    }
    connect() {
        const proto = location.protocol === 'https:' ? 'wss' : 'ws';
        this.ws = new WebSocket(`${proto}://${location.host}/?action=goog-device-list`);
        this.ws.onmessage = this.handleMessage;
        this.ws.onclose = () => { this.timer = setTimeout(() => this.connect(), 3000); };
    }
    destroy() {
        if (this.timer !== null)
            clearTimeout(this.timer);
        this.ws?.close();
    }
}
